import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Container from './Container';
import EmptyButton from './EmptyButton';
import CloseIcon from '../images/CloseIcon';
import Text from './Text';
import Form from './Form';
import Loader from './Loader';

const StepperForm = ({
  totalSteps,
  stepContents,
  onSubmit,
  loading,
  disabled,
  error,
  onClose,
  mode,
  stepsTitle,
  ...props
}) => {
  const [currentStep, setCurrentStep] = useState(1);

  const handleNext = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrev = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  let buttonPosition;

  if (loading) {
    buttonPosition = 'center';
  } else if (currentStep > 1) {
    buttonPosition = 'space-between';
  } else {
    buttonPosition = 'end';
  }

  return (
    <>
      {mode === 'mobile' && (
        <Container
          display="flex"
          justifyContent="space-between"
          margin="20px 30px 0 30px"
        >
          {Array.from({ length: totalSteps }).map((_, index) => (
            <Container
              key={`${index + totalSteps}`}
              width={`${100 / totalSteps}%`}
              height="5px"
              backgroundColor={currentStep >= index + 1 ? '#285AFF' : '#D9D9D9'}
              borderRadius="25px"
              marginTop="30px"
              marginRight={index + 1 === totalSteps ? '0px' : '10px'}
              transition={
                currentStep >= index + 1
                  ? 'background-color 0.3s ease'
                  : undefined
              }
            />
          ))}
        </Container>
      )}
      <Container
        padding="30px 30px 15px 30px"
        color="black"
        fontSize="24px"
        fontWeight="600"
        borderTopLeftRadius="20px"
        borderTopRightRadius="20px"
        display="flex"
        justifyContent="space-between"
      >
        <Text>{stepsTitle[currentStep - 1]}</Text>
        <EmptyButton
          onClick={() => {
            onClose();
          }}
          display="flex"
          alignItems="center"
        >
          <CloseIcon fill="black" />
        </EmptyButton>
      </Container>
      <Container margin="0 auto" padding="20px" {...props}>
        <Form onSubmit={onSubmit}>
          {stepContents.map((stepContent, index) => (
            <Container
              key={stepContent.id}
              display={currentStep === index + 1 ? 'block' : 'none'}
              marginBottom={currentStep === index + 1 ? '20px' : undefined}
              transition="transform 0.3s ease"
              transform={
                currentStep === index + 1 ? 'translateX(0)' : undefined
              }
            >
              {stepContent.content}
            </Container>
          ))}

          {mode === 'desktop' && (
            <Container
              display="flex"
              justifyContent="space-between"
              margin="20px 0"
            >
              {Array.from({ length: totalSteps }).map((_, index) => (
                <Container
                  key={`${index + totalSteps}`}
                  width={`${100 / totalSteps}%`}
                  height="5px"
                  backgroundColor={
                    currentStep >= index + 1 ? '#285AFF' : '#D9D9D9'
                  }
                  borderRadius="25px"
                  marginTop="30px"
                  marginRight={index + 1 === totalSteps ? '0px' : '10px'}
                  transition={
                    currentStep >= index + 1
                      ? 'background-color 0.3s ease'
                      : undefined
                  }
                />
              ))}
            </Container>
          )}

          <Container display="flex" justifyContent={buttonPosition}>
            {loading ? (
              <Loader height="50px" width="auto" />
            ) : (
              <>
                {currentStep > 1 && (
                  <EmptyButton
                    fontSize="16px"
                    color={mode === 'desktop' ? '#285AFF' : 'white'}
                    backgroundColor={mode === 'mobile' && '#285AFF'}
                    padding="10px 20px"
                    borderRadius="100px"
                    fontWeight="600"
                    onClick={handlePrev}
                    position={mode === 'mobile' && 'fixed'}
                    bottom={mode === 'mobile' && '80px'}
                    left={mode === 'mobile' && '30px'}
                    right={mode === 'mobile' && '30px'}
                  >
                    Previous
                  </EmptyButton>
                )}
                {currentStep <= totalSteps && (
                  <EmptyButton
                    fontSize="16px"
                    color={mode === 'desktop' ? '#285AFF' : 'white'}
                    backgroundColor={mode === 'mobile' && '#285AFF'}
                    padding="10px 20px"
                    borderRadius="100px"
                    fontWeight="600"
                    type={currentStep === totalSteps ? 'submit' : undefined}
                    onClick={currentStep === totalSteps ? onSubmit : handleNext}
                    loading={loading}
                    disabled={currentStep === totalSteps ? disabled : false}
                    _disabled={
                      mode === 'desktop'
                        ? {
                            color: 'text400',
                          }
                        : {
                            color: 'white',
                            backgroundColor: '#D9D9D9',
                          }
                    }
                    position={mode === 'mobile' && 'fixed'}
                    bottom={mode === 'mobile' && '30px'}
                    left={mode === 'mobile' && '30px'}
                    right={mode === 'mobile' && '30px'}
                  >
                    {currentStep === totalSteps ? 'Send' : 'Next'}
                  </EmptyButton>
                )}
              </>
            )}
          </Container>
        </Form>
      </Container>
    </>
  );
};

StepperForm.propTypes = {
  totalSteps: PropTypes.number.isRequired,
  stepContents: PropTypes.arrayOf(PropTypes.node).isRequired,
  stepsTitle: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  mode: PropTypes.string,
};

StepperForm.defaultProps = {
  loading: false,
  disabled: true,
  error: false,
  mode: 'desktop',
};

export default StepperForm;
